"use client";

import Link from "next/link";
import { motion } from "framer-motion";
import { Home } from "lucide-react";

import { Button } from "@acme/ui/button";

export default function NotFound() {
  return (
    <div className="h-page relative flex flex-col items-center justify-center">
      <motion.div
        initial={{ opacity: 0.1 }}
        animate={{ opacity: 0.05 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-1/2 z-0 -mt-8 flex h-fit w-full -translate-y-1/2 items-center justify-center mask-b-from-10% mask-radial-[60%_90%] mask-radial-from-80% text-[clamp(4rem,40vw,50rem)] leading-none font-bold select-none"
      >
        404
      </motion.div>
      <motion.div
        initial={{ opacity: 0, filter: "blur(16px)", y: 32 }}
        animate={{ opacity: 1, filter: "blur(0px)", y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut", delay: 0.4 }}
        className="relative z-10 flex flex-col items-center text-center"
      >
        <div className="text-muted-foreground mb-4 text-lg font-semibold">
          Ooops!
        </div>
        <h1 className="mb-4 text-3xl leading-[1.3] font-bold md:text-5xl">
          This is not the page <br />
          <span className="text-primary font-mono font-normal tracking-tight">
            you’re looking for{" "}
            <span
              role="img"
              aria-label="eyes"
              className="text-[0.7em] leading-6"
            >
              👀
            </span>
          </span>
        </h1>
        <p className="text-muted-foreground mb-8 max-w-md text-base text-balance md:text-xl">
          But no worries — hit the button below and we’ll get you back on track.
        </p>

        <Button
          asChild
          size="lg"
          className="px-4 font-medium"
          effect="shine"
          variant={"outline"}
        >
          <Link href="/">
            <Home className="size-4" />
            <span className="sr-only">Back to Home</span>
            Back to Home
          </Link>
        </Button>
      </motion.div>
    </div>
  );
}
